// Copyright © 2021 Move Closer
import messagesEN from './en.json';
import messagesPl from './pl.json';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const locales = {
    en: messagesEN,
    pl: messagesPl
};
